import {useNavigate} from 'react-router-dom';
import {useEffect} from 'react';

export default function Error404Page() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/');
  }, []);

  return null;
}